import { AssigneeTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'

export const REQUESTOR_ID = 'requestor'

export const ASSESSMENT_OWNER_ID = 'businessOwner'

export const requestorAssignee = {
  value: 'Requestor',
  id: REQUESTOR_ID,
  type: AssigneeTypeEnum.VARIABLE,
  name: 'Requestor',
}

export const assessmentOwnerAssignee = {
  value: 'Business Owner',
  id: ASSESSMENT_OWNER_ID,
  type: AssigneeTypeEnum.VARIABLE,
  name: 'Business Owner',
}
